import { SharedConstants } from "../../../shared/constants/shared.constants";
export class ViewApplicationStepManagementConstants {
    static NEXT_STEPS_FORM_CONTROL_NAME = "nextSteps";
    static REASON_FORM_CONTROL_NAME = "reasonForMove";
    static ACCEPT_FORM_CONTROL_NAME = "accept";
    static COMPONENT_NAME = "Step management";
    static CURRENT_STEPS_LABEL = "Current steps";
    static AVAILABLE_STEPS_LABEL = "Available steps to move to";
    static DISCLAIMER_LABEL = "Disclaimer";
    static REASON_LABEL = "Reason for move";
    static I_AGREE_LABEL = "I agree to the terms";
    static MOVE_APPLICATION_BUTTON_LABEL = "Move application";
    static UPGRADE_APPLICATION_BUTTON_LABEL = "Upgrade workflow";
    static REASON_ERROR = "Reason " + SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION;
    static AVAILABLE_STEPS_ERROR = "Step " + SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION;
    static ACCEPT_ERROR = "Please accept the disclaimer before moving the application";
    static SUCCESS_MESSAGE = "Application moved successfully.";
    static WORKFLOW_SUCCESS_MESSAGE = "Workflow upgraded successfully.";
    static DISCLAIMER = "Whilst every effort has been made to capture information in compliance with mSCOA (Municipal Standard Chart of Accounts) and SPLUMA (Spatial Planning and Land Use Management Act of 2013) requirements, " +
        "in no respect shall Esri South Africa incur any liability for any consequences arising from the use or application of this data/information. While every reasonable effort is made to maintain current and accurate information within " +
        "any AFLA module, in no respect shall Esri South Africa incur any liability for any error, omission, or loss of data or, for direct or indirect damage as a result of the usage of or, " +
        "by quoting the content on the site or the information delivered or not delivered or, as a result of capturing and storing data in these modules. " +
        "In no respect shall Esri South Africa incur any liability for any breaches in respect of timelines to deliver actionable steps within the various workflows, " +
        "in alignment with municipal bylaws and as per the Spatial Planning and Land Use Management Act of 2013.";
    static MODAL_DIALOG_TITLE = "Are you sure you want to continue?";
    static MODAL_DIALOG_MESSAGE = "Please note that the process is not reversible. Do you want to continue?";
    static MODAL_OPTIONS = {
        size: "xl",
        centered: true,
        keyboard: false,
        backdrop: "static"
    };
}
